import { configureStore } from "@reduxjs/toolkit";
import registerReducer from "./slices/registerSlice";
import setprofileReducer from "./slices/profilesetSlice";
import loginReducer from "./slices/loginSlice";
import authReducer from "./slices/authSlice";
import { setupAxiosInterceptors } from "../services/axiosInstance";
import setServiceReducer from "./slices/serviceRegSlice";
import profileReducer from "./slices/profileSlice";
import mealReducer from "./slices/mealsetupSlice";
import pickUpaddressReducer from "./slices/setAddrssSlice";
import addCustomerReducer from "./slices/addCustomerSlice";
import addCustomerAddressReducer from "./slices/customerAddSlice";
import faqReducer from "./slices/faqSlice";
import orderCustomerReducer from "./slices/orderCustomerSlice";
import orderDraftReducer from "./slices/orderDraftSlice";
import subscriptionReducer from "./slices/SubscriptionDraftSlice";
import orderReducer from "./slices/orderSlice";
import recordReducer from "./slices/customerRecordSlice";
import planreducer from "./slices/deliverAnorderSlice";
import dashReducer from "./slices/dashboardSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    login: loginReducer,
    register: registerReducer,
    setupProfile: setprofileReducer,
    profile: profileReducer,
    setService: setServiceReducer,
    setMeal: mealReducer,
    pickUpAdd: pickUpaddressReducer,
    addCustomers: addCustomerReducer,
    customerAddress: addCustomerAddressReducer,
    faqs: faqReducer,
    customerOrder: orderCustomerReducer,
    orderDraft: orderDraftReducer,
    order: orderReducer,
    customerRecords: recordReducer,
    subscribeDraft: subscriptionReducer,
    planSlice: planreducer,
    dashboard: dashReducer,
  },
});

setupAxiosInterceptors(store);
